import {
  SHORTCUT_PAGE_INFO_FIELDS,
  SHORTCUT_LABELS_FIELDS
} from '@@partner:graphql/shortcuts'
import type { ProductListItem } from '@@partner:types:app'
import type {
  CommonSort,
  NestedFilter,
  CommonPager,
  PageInfo
} from '@@partner:types:graphql'

import { gql, useLazyQuery, useQuery } from '@apollo/client'

export interface FetchProducts {
  products: {
    edges: ProductListItem[]
    pageInfo: PageInfo
  }
}

export interface FetchProductsVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager: CommonPager
}

export const GQL_QUERY_FETCH_PRODUCTS = gql`
  query(
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    products: allProducts(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
      edges {
        id
        name
        xid
        article_num
        status
        price_type
        preview {
          url
        }
        allPrices {
          id
          shop_id
          currentPrice
          olderPrice
          salePeriod {
            start
            finish
          }
          shop {
            id
            name
          }
        }

        allStocks {
          shop_id
          amount
        }
        marketingLabels {
          ${SHORTCUT_LABELS_FIELDS}
        }
        categories {
          id
          name
        }
        indexable
      }
    }
  }
`

export const useQueryProducts = (variables?: FetchProductsVariables) => {
  return useQuery<FetchProducts, FetchProductsVariables>(
    GQL_QUERY_FETCH_PRODUCTS,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )
}

export const useLazyQueryProducts = (variables?: FetchProductsVariables) => {
  return useLazyQuery<FetchProducts, FetchProductsVariables>(
    GQL_QUERY_FETCH_PRODUCTS
  )
}
